import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { SelectSubscriptionFormContext } from "./SelectSubscriptionFormContext";

export const useSelectSubscriptionFormProvider = () => {
  const context = useContext(SelectSubscriptionFormContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useSelectSubscriptionFormProvider",
      "SelectSubscriptionFormContext"
    );
  }

  return context;
};
